<template>
  <v-dialog
    v-model="isOpen"
    max-width="790"
    width="530"
    :persistent="isPersistent"
    @keydown.prevent.enter="executeMainAction"
  >
    <v-card class="dialog-box">
      <v-card-title class="headline">{{ title }}</v-card-title>

      <v-card-text>{{ content }}</v-card-text>

      <v-card-subtitle>
        <slot name="dialog-textbox" />
      </v-card-subtitle>

      <v-card-actions>
        <v-btn
          v-if="secondaryActionDisable"
          @click="executeSecondaryAction"
          :ripple="false"
          class="secondary-button"
          text
          :loading="loading"
        >
          {{ secondaryActionLabel }}
        </v-btn>
        <v-btn
          @click="executeMainAction"
          :ripple="false"
          class="main-button"
          text
          :disabled="loading"
        >
          {{ mainActionLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AppDialogBox",

  props: {
    /**
     * Defines if the dialog box is open or not.
     */
    open: {
      type: Boolean,
      required: true
    },
    /**
     * Title of the dialog box.
     */
    title: {
      type: String,
      required: true
    },
    /**
     * Main text inside the dialog box
     */
    content: {
      type: String,
      required: true
    },
    /**
     * Label of the main action button
     */
    mainActionLabel: {
      type: String,
      required: true
    },
    /**
     * Label of the secondary action button
     */
    secondaryActionLabel: {
      type: String,
      required: true
    },

    /**
     * Defines if the dialog box can be closed by clicking outside of it
     */
    isPersistent: {
      type: Boolean,
      default: true
    },

    /**
     * Determines if the second button is loading and the main one is disabled
     */
    loading: {
      type: Boolean,
      default: false
    },

    /**
     * Determines if the secondary button is disabled
     */
    secondaryActionDisable: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      /**
       * determines if the dialog box is open
       */
      isOpen: false
    };
  },

  watch: {
    /**
     * Whenever the value of the 'open' variable is changed,
     * the 'isOpen' variable remains with the same value
     * @param newValue
     */
    open(newValue) {
      this.isOpen = newValue;
    }
  },

  methods: {
    /**
     * Send an event to the parent to execute the main action.
     */
    executeMainAction() {
      this.$emit("mainAction");
    },
    /**
     * Send an event to the parent to execute the secondary action.
     */
    executeSecondaryAction() {
      this.$emit("secondaryAction");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/_Molecules/AppDialogBox.vue